import { type ComponentPropsWithRef, forwardRef } from "react";
import * as styles from "./styles.css";

type Props = Omit<ComponentPropsWithRef<"select">, "type"> & {
  selected: boolean;
  hasError?: boolean;
  placeholder?: string;
  // true の場合、プレースホルダーを選択不可（disabled + hidden）にする
  isPlaceholderDisabled?: boolean;
  options: readonly OptionProps[];
};

export type OptionProps<T = string | number> = {
  label: string;
  value: T;
  disabled?: boolean;
};

export const SelectBox = forwardRef<HTMLSelectElement, Props>(
  (
    { selected, hasError, className, placeholder, isPlaceholderDisabled, options, ...props },
    ref,
  ) => (
    <select
      className={`${styles.variant[selected ? "selected" : "unselected"]} ${
        hasError ? styles.hasError : ""
      } ${className || ""}`}
      {...props}
      ref={ref}
    >
      {placeholder && (
        <option
          value=""
          className={styles.placeholderOption}
          disabled={isPlaceholderDisabled}
          hidden={isPlaceholderDisabled}
        >
          {placeholder}
        </option>
      )}
      {/* eslint-disable-next-line no-shadow */}
      {options.map(({ label, value, disabled = false }) => (
        <option key={label} value={value} disabled={disabled} className={styles.option}>
          {label}
        </option>
      ))}
    </select>
  ),
);
SelectBox.displayName = "SelectBox";
